module.exports = __webpack_public_path__ + "img/supportSWAP.2736b630.png";